import { createMigration } from './utils';

export const migrationTo9_194 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            const textDirection = map.getIn(['captions', 'asset', 'transcript', 'textDirection'], null) ?? 'ltr';
            map.setIn(['captions', 'asset', 'transcript', 'textDirection'], textDirection);

            const origTextDirection = map.getIn(['originalTranscript', 'textDirection'], null) ?? 'ltr';
            map.setIn(['originalTranscript', 'textDirection'], origTextDirection);
        });
    },
});
